import * as React from 'react'

export const CheckboxGroupContext = React.createContext<{
  value?: Set<string>
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onChangeALLItemCheck: (e: React.ChangeEvent<HTMLInputElement>) => void
  addToValue: (addedValue: string) => void
  isAllCheck?: boolean
  registChipStore: (addedValue: string) => void
  setAllCheckValue?: (value: string) => void
  name?: string
} | null>(null)
